import React from 'react';
const TextInput = (props) => {
    const { orgMetadataField, onChange, isRequired, hasRequiredError, val } = props;
    return (React.createElement("div", { className: 'form-input-group' },
        React.createElement("label", { className: 'input-label', htmlFor: orgMetadataField.name },
            orgMetadataField.name,
            " ",
            isRequired ? '*' : ''),
        React.createElement("input", { type: 'text', id: orgMetadataField.name, "data-testid": `test-input-${orgMetadataField.name}`, className: 'input', name: orgMetadataField.name, value: val || '', placeholder: orgMetadataField.name, onChange: e => onChange(orgMetadataField.name, e.target.value) }),
        isRequired && hasRequiredError &&
            React.createElement("span", { className: 'required-error' }, "Required")));
};
export default TextInput;
